import React, { useState, useEffect } from 'react';
import { NavLink, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './Nav.module.css';

// ── Brand mark — coin logo (H23.1: full sidebar width with side margin) ───
function TicketLogo() {
  return (
    <img
      src="/voxpop-coin-logo.png"
      alt="VoxPop"
      style={{
        display: 'block',
        width: 240,
        maxWidth: 'calc(100% - 32px)',
        height: 'auto',
        margin: '0 auto',
      }}
    />
  );
}

// ── Flat SVG line icons (16×16, 1.4px stroke) ────────────────
const IconHowItWorks = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2.5" y="1" width="11" height="14" rx="1.5"/>
    <line x1="5" y1="5.5" x2="11" y2="5.5"/>
    <line x1="5" y1="8" x2="11" y2="8"/>
    <line x1="5" y1="10.5" x2="8.5" y2="10.5"/>
  </svg>
);
const IconLibrary = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="3" width="14" height="10" rx="1.5"/>
    <line x1="3" y1="3" x2="3" y2="13"/>
    <line x1="13" y1="3" x2="13" y2="13"/>
    <polygon points="6.5,5.5 6.5,10.5 11,8" fill="currentColor" stroke="none"/>
  </svg>
);
const IconTrailers = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="8" cy="8" r="6.5"/>
    <polygon points="6.5,5.5 6.5,10.5 11,8" fill="currentColor" stroke="none"/>
  </svg>
);
const IconStandings = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <line x1="2" y1="14" x2="14" y2="14"/>
    <rect x="3" y="8" width="2.5" height="6" rx="0.5" fill="currentColor" stroke="none"/>
    <rect x="6.75" y="5" width="2.5" height="9" rx="0.5" fill="currentColor" stroke="none"/>
    <rect x="10.5" y="2" width="2.5" height="12" rx="0.5" fill="currentColor" stroke="none"/>
  </svg>
);
const IconEvents = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1.5" y="3" width="13" height="12" rx="1.5"/>
    <line x1="1.5" y1="7" x2="14.5" y2="7"/>
    <line x1="5" y1="1.5" x2="5" y2="4.5"/>
    <line x1="11" y1="1.5" x2="11" y2="4.5"/>
  </svg>
);
const IconAccount = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="8" cy="5.5" r="3"/>
    <path d="M2 14c0-3.3 2.7-6 6-6s6 2.7 6 6"/>
  </svg>
);
const IconMerch = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 5h10l-1.5 9H4.5L3 5z"/>
    <path d="M5.5 5V4a2.5 2.5 0 015 0v1"/>
  </svg>
);
const IconFAQs = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M13 2H3a1.5 1.5 0 00-1.5 1.5v7A1.5 1.5 0 003 12h2l1.5 2.5L8 12h5a1.5 1.5 0 001.5-1.5v-7A1.5 1.5 0 0013 2z"/>
    <text x="8" y="10.5" textAnchor="middle" fontSize="7" fontWeight="bold" fill="currentColor" stroke="none" fontFamily="serif">?</text>
  </svg>
);
const IconAbout = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1.5" y="4" width="13" height="8" rx="1.5"/>
    <circle cx="5.5" cy="8" r="1.8"/>
    <line x1="8.5" y1="6.5" x2="12.5" y2="6.5"/>
    <line x1="8.5" y1="9.5" x2="11" y2="9.5"/>
  </svg>
);
const IconContact = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1.5" y="3.5" width="13" height="9" rx="1.5"/>
    <polyline points="1.5,4.5 8,9.5 14.5,4.5"/>
  </svg>
);
const IconAdmin = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="8" cy="8" r="2.5"/>
    <path d="M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.4 3.4l1.4 1.4M11.2 11.2l1.4 1.4M3.4 12.6l1.4-1.4M11.2 4.8l1.4-1.4"/>
  </svg>
);

const LINKS = [
  { to: '/how-it-works', Icon: IconHowItWorks, label: 'How It Works' },
  { to: '/library',      Icon: IconLibrary,    label: 'Library' },
  { to: '/trailers',     Icon: IconTrailers,   label: 'Trailers' },
  { to: '/standings',    Icon: IconStandings,  label: 'Scores & Standings' },
  { to: '/events',       Icon: IconEvents,     label: 'Events' },
  { to: '/merch',        Icon: IconMerch,      label: 'Merch' },
  { to: '/faqs',         Icon: IconFAQs,       label: 'FAQs' },
  { to: '/about',        Icon: IconAbout,      label: 'About' },
  { to: '/contact',      Icon: IconContact,    label: 'Contact' },
];

// ── Filmstrip sidebar — 3 posters with per-poster film borders ──
// Only 3 unique posters — duplicated once for seamless scroll loop
const POSTER_IMGS = [
  '/posters/Dark_Knight_Poster.jpg',
  '/posters/Mission_Impossible_poster.jpeg',
  '/posters/Dolls_of_VooDoo.jpg',
];

// Sprocket hole row rendered between every poster
function FilmBorder() {
  return (
    <div className={styles.filmBorder}>
      <span /><span /><span /><span /><span />
    </div>
  );
}

function FilmStrip({ user, handleLogout }) {
  const reel = [...POSTER_IMGS, ...POSTER_IMGS]; // 2× for seamless -50% loop
  return (
    <div className={styles.filmStrip}>
      {/* Scrolling reel — border → poster → border → poster → … */}
      <div className={styles.filmFramesOuter}>
        <div className={styles.filmFrames}>
          {reel.map((src, i) => (
            <React.Fragment key={i}>
              <FilmBorder />
              <div className={styles.filmFrame}>
                <img src={src} alt="" aria-hidden="true" />
              </div>
            </React.Fragment>
          ))}
          {/* Closing border so the loop joins cleanly */}
          <FilmBorder />
        </div>
      </div>

      {/* Auth buttons — pinned to bottom inside the filmstrip */}
      <div className={styles.filmAuth}>
        {user ? (
          <>
            <Link to="/dashboard" className={styles.filmAuthBtn}>My Account</Link>
            <button className={styles.filmAuthBtnOutline} onClick={handleLogout}>Log Out</button>
          </>
        ) : (
          <>
            <Link to="/login"    className={styles.filmAuthBtnOutline}>Login</Link>
            <Link to="/register" className={styles.filmAuthBtn}>Sign Up</Link>
          </>
        )}
      </div>
    </div>
  );
}

// ── Sidebar nav inner content ─────────────────────────────────
function SidebarInner({ user, walletDollars, handleLogout }) {
  return (
    <>
      <Link to="/" className={styles.logoWrap}><TicketLogo /></Link>
      <div className={styles.authRow}>
        {user ? (
          <>
            <div className={styles.authName}>{user.displayName || user.display_name || user.username}</div>
            <div className={styles.authEmail}>{user.email}</div>
            <div className={styles.walletBadge}>◈ {walletDollars}</div>
            <div className={styles.authBtns}>
              <Link to="/wallet" className="btn btn-outline-magenta btn-sm">Wallet</Link>
              <button className="btn btn-ghost btn-sm" onClick={handleLogout}>Log Out</button>
            </div>
          </>
        ) : (
          <div className={styles.authBtns}>
            <Link to="/login"    className="btn btn-ghost btn-sm">Login</Link>
            <Link to="/register" className="btn btn-magenta btn-sm">Sign Up</Link>
          </div>
        )}
      </div>
      <div className={styles.nav}>
        {user && (
          <>
            <NavLink to="/dashboard" className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ''}`}>
              <span className={styles.linkIcon}><IconAccount /></span>My Account
            </NavLink>
            <hr className={styles.linkDivider} />
          </>
        )}
        {LINKS.map(({ to, Icon, label }) => (
          <NavLink key={to} to={to} className={({ isActive }) =>
            `${styles.link} ${isActive ? styles.active : ''}`}>
            <span className={styles.linkIcon}><Icon /></span>
            {label}
          </NavLink>
        ))}
        {user?.role === 'admin' && (
          <>
            <hr className={styles.linkDivider} />
            <NavLink to="/admin" className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ''}`}>
              <span className={styles.linkIcon}><IconAdmin /></span>Admin
            </NavLink>
          </>
        )}
      </div>
      <div className={styles.bottom}>
        <div className={styles.socials}>
          <a href="https://instagram.com" target="_blank" rel="noreferrer" className={styles.socialLink} aria-label="Instagram">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
            </svg>
            <span>Instagram</span>
          </a>
          <a href="https://reddit.com" target="_blank" rel="noreferrer" className={styles.socialLink} aria-label="Reddit">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M22 11.82a2.36 2.36 0 0 0-4-1.66 11.63 11.63 0 0 0-6.19-1.94l1.2-3.79 3.25.77a1.88 1.88 0 1 0 .22-1l-3.68-.87a.5.5 0 0 0-.6.34l-1.37 4.55a11.65 11.65 0 0 0-6.2 1.94 2.36 2.36 0 1 0-2.6 3.85 4.27 4.27 0 0 0-.05.65c0 3.55 4.14 6.44 9.24 6.44s9.24-2.89 9.24-6.44a4.27 4.27 0 0 0-.05-.65A2.37 2.37 0 0 0 22 11.82zM6.76 13.7a1.48 1.48 0 1 1 1.48 1.48 1.48 1.48 0 0 1-1.48-1.48zm8.36 3.95a4.58 4.58 0 0 1-3.12.95 4.58 4.58 0 0 1-3.12-.95.44.44 0 1 1 .62-.62 3.76 3.76 0 0 0 2.5.7 3.76 3.76 0 0 0 2.5-.7.44.44 0 1 1 .62.62zm.14-2.47a1.48 1.48 0 1 1 1.48-1.48 1.48 1.48 0 0 1-1.48 1.48z" />
            </svg>
            <span>Reddit</span>
          </a>
        </div>
      </div>
    </>
  );
}

export default function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => { setOpen(false); }, [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const handleLogout = () => { logout(); navigate('/'); };
  const walletDollars = user ? `$${((user.walletBalance || 0) / 100).toFixed(2)}` : null;

  return (
    <>
      <button
        className={`${styles.hamburger} ${open ? styles.open : ''}`}
        onClick={() => setOpen(o => !o)}
        aria-label="Toggle menu"
      >
        <span /><span /><span />
      </button>

      {/* Filmstrip retired in H14. FilmStrip component and related helpers
          (POSTER_IMGS, FilmBorder) remain defined below in case of rollback. */}

      <div
        className={`${styles.backdrop} ${open ? styles.open : ''}`}
        onClick={() => setOpen(false)}
        aria-hidden="true"
      />

      <nav className={`${styles.sidebar} ${open ? styles.open : ''}`}>
        <SidebarInner user={user} walletDollars={walletDollars} handleLogout={handleLogout} />
      </nav>
    </>
  );
}
